module.exports = __webpack_public_path__ + "static/media/2122-service-2-3-min.5bd14822.jpg";